/**
 * Получение данных программы (operator, program_id, shortname, name, program_group_id)
 * для конкретного региона.
 * @param {Array} programs Общий список программ из API
 * @param {Event|HTMLElement} source Событие change селекта программы (главная) либо элемент
 *   с атрибутом shortname (option главной формы или скрытый инпут страницы программы)
 * @param {string|number|null} regionId Id выбранного в форме региона — привязки к конкретному
 *   региону больше нет (см. MARKDEV-933), используется тот, что реально выбрал пользователь
 */
const getDataProgram = (programs, source, regionId) => {
  let operator = "",
    program_id = null,
    shortname = "",
    program_group_id = null,
    name = "";

  /* Проверяем это option/инпут или событие */
  const element = source?.target
    ? source.target.options[source.target.selectedIndex]
    : source;

  if (!element) {
    return { operator, program_id, shortname, name, program_group_id };
  }

  /* Из всего списка программ находим свою, независимо от региона */
  const program = programs.find(
    (item) => item.shortname == element.getAttribute("shortname"),
  );

  if (!program) {
    return { operator, program_id, shortname, name, program_group_id };
  }

  name = program.name;
  shortname = program.shortname;
  /* Общий id программы одинаков для всех регионов, поэтому не зависит от regionId */
  program_group_id = program.program_group_id ?? null;

  /* Привязка программы к выбранному региону (её может не быть) */
  const regionData = program.regions?.find(
    (item) => item.region_id == regionId,
  );

  if (regionData) {
    program_id = regionData.program_id;

    regionData.fields?.forEach((field) => {
      if (field.field == "funnel") {
        operator = field.value;
      }
    });
  }

  return { operator, program_id, shortname, name, program_group_id };
};

export default getDataProgram;
